<template>
  <stage-card progress="IN_PROGRESS">
    <template #header>{{ title }}</template>
    <template #progress-chip>
      <v-skeleton-loader type="chip" />
    </template>
    <template #content>
      <v-skeleton-loader
        v-for="i in columns"
        :key="i"
        type="list-item-three-line"
      />
    </template>
    <template #actions>
      <v-skeleton-loader type="button" />
    </template>
  </stage-card>
</template>

<script>
import StageCard from './StageCard';

export default {
  name: 'StageCardSkeletonLoader',
  components: { StageCard },
  props: {
    title: {
      type: String,
      required: true,
    },
    columns: {
      type: Number,
      default: 2,
    },
  },
};
</script>

<style lang="scss" scoped></style>
